import React from 'react';
import styled from 'styled-components';
import { Body1, H3 } from 'ensightful-koala-ui';
import {
    ModalWithStyles,
    ModalInnerContainer,
    BodyContainer,
    InnerTopConatiner,
    ModalFooterContainer,
} from 'components/organisms/SignUp/SignUpComponents';
import assetFiles from 'utils/asset';

const ResendButton = styled.span`
    text-decoration: underline;
    color: #6347ff;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;

    &:hover {
        cursor: pointer;
    }
`;

const EmailVerification = ({ visible, resendEmail }) => {
    return (
        <ModalWithStyles
            closable={false}
            centered
            mask={false}
            visible={visible}
            destroyOnClose
            maskClosable
            width={440}
            footer={null}
        >
            <ModalInnerContainer>
                <BodyContainer style={{ margin: 0 }}>
                    <InnerTopConatiner style={{ flexDirection: 'column' }}>
                        <img src={assetFiles.image.email_verification_graphic} />
                    </InnerTopConatiner>
                    <H3>Verify Your Email</H3>
                    <Body1 style={{ textAlign: 'center', margin: '40px 0px 80px 0px' }}>
                        To complete the signup process, check your inbox and click the link to verify your email.
                    </Body1>
                </BodyContainer>
            </ModalInnerContainer>
            <ModalFooterContainer>
                <Body1>
                    Didn’t receive the email? <ResendButton onClick={resendEmail}>Resend Email</ResendButton>
                </Body1>
            </ModalFooterContainer>
        </ModalWithStyles>
    );
};

export default EmailVerification;
